import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'

import Buefy from 'buefy'
import '../css/mystyles.css'

import '@mdi/font/css/materialdesignicons.css'

Vue.use(Buefy, {
  defaultIconPack: 'mdi'
})

Vue.use(Buefy)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
